import { render, staticRenderFns } from "./HomeRock.vue?vue&type=template&id=221b45af&"
import script from "./HomeRock.vue?vue&type=script&lang=js&"
export * from "./HomeRock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports